<template>

<div class="cookie js-cookie-popup" v-bind:class="{_active: isOpen}">
			<div class="cookie__content">
				<div class="cookie__message">
					<p class="cookie__a">{{ linkText }}</p>
					<p>{{ message }}</p>
					<div class="cookie__button" @click="accept"><span>{{ buttonTextAccept }}</span></div>
				</div>
			</div>
</div>
  <!-- <div class="cookie-widget" v-if="isOpen">
    <div class="cookie-widget__content">
      <div class="cookie-widget__message">
        <p><a href="storage/documents/soglasie_na_obrabotku_faylov_cookie.pdf" target="_blank">{{ linkText }}</a>
          {{ message }}</p>
        <div class="cookie-widget__button" @click="accept"><span>{{ buttonTextAccept }}</span></div>
      </div>
    </div>
  </div> -->
</template>

<script>
export default {
  props: {
    buttonTextAccept: {
      type: String,
      default: 'СОГЛАСЕН',
    },
    message: {
      type: String,
      default: 'Продолжая использовать сайт, Вы даете АНО НАРК (ИНН 7710475530), согласие на обработку файлов '+
      'cookies и пользовательских данных. Если Вы не хотите, чтобы Ваши вышеперечисленные данные '+
      'обрабатывались, просим отключить обработку файлов cookies и сбор пользовательских данных в '+
      'настройках Вашего браузера или покинуть сайт.'
    },
    linkText: {
      type: String,
      default: 'Согласие на обработку файлов cookies'
    }
  },
  data() {
    return {
          isOpen: false,
        }
  },
  created() {
    if (!this.getGDPR()) {
      setTimeout(() => {
      this.isOpen = true
    }, 1*3000);
      
    }
  },
  methods: {
    getGDPR() {
      return localStorage.getItem('GDPR:accepted') ?? false;
    },
    accept() {
          this.isOpen = false;
          localStorage.setItem('GDPR:accepted', 'true');
    },
  },
    computed: {

    }
}
</script>
<style>

.cookie {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  color: #013085;
  -webkit-transform: translateY(120%);
     -moz-transform: translateY(120%);
      -ms-transform: translateY(120%);
       -o-transform: translateY(120%);
          transform: translateY(120%);
  -webkit-transition: -webkit-transform .5s;
  transition: -webkit-transform .5s;
  -o-transition: -o-transform .5s;
  -moz-transition: transform .5s, -moz-transform .5s;
  transition: transform .5s;
  transition: transform .5s, -webkit-transform .5s, -moz-transform .5s, -o-transform .5s;
  font-size: 14px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
     -moz-box-sizing: border-box;
          box-sizing: border-box;
  padding: 17px 57px;
  -webkit-box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
     -moz-box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  z-index: 99; }
  .cookie._active {
    -webkit-transform: none;
       -moz-transform: none;
        -ms-transform: none;
         -o-transform: none;
            transform: none; }
  .cookie__content {
    /* max-width: 1200px; */
    margin: 0 auto; }
  .cookie__a {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 0.8rem; }
  .cookie__button {
    display: inline-block;
    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
            box-sizing: border-box;
    padding: 14.5px 36px;
    cursor: pointer;
    background: #508aff;
    border-radius: 0.5rem;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 14px;
    -webkit-transition: all ease .3s;
    -o-transition: all ease .3s;
    -moz-transition: all ease .3s;
    transition: all ease .3s; }
  .cookie__button:hover {
    background: #6a9bff; }
  .cookie__message {
    max-width: 1300px;
  }

</style>